/**
 * @file   参考文献
 * @create macaiqi 2021/12/02
 * @update
 */
import React, { useEffect, useState } from 'react';
import Bread from '../../common/Bread'
import { queryDocumentList } from '../../../shared/api';
import { Pager } from '@portal-site/pager';
import usePage from '../../../components/Hooks/usePage';
import './index.scss'
const Refenrences = () => {
  const [data, setData] = useState([]);
  const [initPage, setPage] = usePage(1);

  useEffect(() => {
    queryDocumentList({
      current: initPage,
      size: 40
    }).then(res => {
      setData(res)
    })
  }, [initPage])
  return (
    <div className="refenrences">
      <Bread title='参考文献' />
      <div className="content">
        <h3>参考文献：</h3>
        {data?.refenrences?.map((item, index) => {
          return (
            <div className="item" key={index}>
              {item.documentName}
            </div>
          )
        })}

      </div>
      {data?.count > 1 && (
        <Pager
          containerClassName="mypager"
          forcePage={initPage || 1}
          pageCount={data?.pages}
          onPageChange={(page) => setPage(page)}
          prevLabel="上一页"
          nextLabel="下一页"
        />
      )}
    </div>
  );
};
export default Refenrences;
